import {
  Box,
  Button,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { useLookupDealerCollection } from '../../../../../hooks/useLookupedDealersCollection'
import { assignDealer } from '../../../../../services/ApiService'
import { notifySuccess } from '../../../../../services/ToastifyService/ToastifyService'
import {
  closeModalFn,
  openModalFn,
} from '../../../../../utils/controllers/ModalController'
import singleRequestStore from '../../../store/SingleRequestStore'
import { RequestType } from '../../../types/Request.type'
import { mapChipValue } from '../../../utils/mapChipValue'
import { mapSelectItems } from '../../../utils/mapSelectItems'
import DealersAutocomplete from '../elements/DealersAutocomplete'
import TypedAccordion from '../elements/TypedAccordion'
import requestDrawerStore from '../RequestDrawerStore'

type DrawerContentDealerProps = {
  request: RequestType
}

export const DrawerContentDealer: FC<DrawerContentDealerProps> = ({
  request,
}) => {
  const [value, setValue] = useState('')
  const invalidate = useInvalidateQueries()
  const { goBack } = requestDrawerStore
  const { updateRequest, updateHistory } = singleRequestStore
  const { getFittedDealers, dealers } = useLookupDealerCollection([request.id])
  const items = mapSelectItems(dealers)

  useEffect(() => {
    getFittedDealers()
  }, [request.id])

  const onChange = (e?: SelectChangeEvent<any>) => {
    const targetValue = e?.target.value

    const currentValue = items.find((el: any) => {
      return el.value === targetValue
    })

    setValue(currentValue?.value as string)
  }

  const onSave = () => {
    openModalFn['progress-backdrop']?.()
    assignDealer({
      dealerId: value,
      orderIds: [request.id],
    })
      .then((res) => {
        if (res?.[0]) {
          updateRequest(res[0])
          updateHistory()
          invalidate(['requests-table'])
          goBack()
          notifySuccess('Дилер назначен')
        }
      })
      .finally(() => {
        closeModalFn['progress-backdrop']?.()
      })
  }

  return (
    <Stack height={'100%'} justifyContent={'space-between'}>
      <TypedAccordion summary={'Назначить на дилера'}>
        <Stack sx={{ padding: '16px' }}>
          {request.dealer ? (
            mapChipValue(request, 'dealer')
          ) : (
            <Typography variant='body1'>Дилер не назначен</Typography>
          )}
        </Stack>
        <DealersAutocomplete
          value={value}
          items={items}
          onChange={onChange}
          label='назначить на Дилера'
        />
      </TypedAccordion>
      <Box px={2}>
        <Button
          color={'primary'}
          variant={'contained'}
          onClick={onSave}
          sx={{ margin: '24px 0 0 0' }}
          fullWidth
          disabled={!value}
        >
          <FormattedMessage id={'сохранить'} />
        </Button>
        <Button
          color={'primary'}
          variant={'outlined'}
          onClick={() => goBack()}
          fullWidth
          sx={{ margin: '8px 0 24px 0' }}
        >
          <FormattedMessage id={'Отмена'} />
        </Button>
      </Box>
    </Stack>
  )
}

export default observer(DrawerContentDealer)
